export default "__VITE_ASSET__CxfPoVOc__"